import { Button, Card, CardBody, CardHeader, Col, Container, Row } from 'reactstrap';
import { useEffect, useState } from 'react';
import { usdFormat } from '../../../Utility/usdFormat';
import { DashIcon } from '@primer/octicons-react';
import { ArrowDropDown, ArrowDropUp } from '@mui/icons-material';
import './Sales.css';
import { Divider } from '@mui/material';
import { analytics } from '../../../firebase';
import { logEvent } from 'firebase/analytics';

type SalesData = {
    month: string;
    monthSalesLY: number;
    monthSalesCY: number;
    monthGrossProfitCY: number;
    monthGrossProfitLY: number;

}

type props = {
    data: SalesData[];
}

type Tab = 'Tab1' | 'Tab2'

const MonthlySalesReportCard = ({ data }: props) => {
    const [ activeTab, setActiveTab ] = useState<Tab>('Tab1');
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "June", "July", "Aug", "Sept", "Oct", "Nov", "Dec"];
    const currentMonth = monthNames[new Date().getMonth()];
    const monthIndex = monthNames.indexOf(currentMonth);

    const convertNumberToDollarSign = (value: number): string => {
        const levels = Math.min(Math.floor(value / 10000), 10)
        return '$'.repeat(levels || 1);
    };

    const handleProfitTab = async () => {
        setActiveTab('Tab2');
        logEvent(analytics, 'view_profit_tab_web', {
            name: 'View Sales Profit Tab',
            description: 'View Sales Profit Tab'
        });
    }

    const tabContent = () => {
        switch (activeTab) {
            case 'Tab1':
                return (
                    <Container className='bg-white'>
                        <Row 
                            style={{ display: 'flex', paddingInline: 20}}
                        >
                            <span 
                                className='headerText'
                                style={{ flex: 1 }}
                            >
                                Month
                            </span>
                            <div style={{ flex: 1 }}></div>
                            <span className='headerText' style={{ flex: 1 }}>Sales CY</span>
                            <span className='headerText' style={{ flex: 1 }}>Sales LY</span>
                        </Row>
                        <Divider style={{ marginBottom: 10, borderColor: 'gray'}} variant='middle'/>
                        {data.map((item, index) => (
                            <Row 
                                key={item.month} 
                                style={{ display: 'flex', paddingInline: 20 }}
                            >
                                <div style={{ flex: 1, marginBottom: 10 }}>
                                    <span className='headerText'>{item.month}</span>
                                </div>
                                <div style={{ flex: 1, marginBottom: 10 }}>
                                    {
                                        monthNames.indexOf(item.month) > monthIndex
                                        ? <DashIcon className='p-2' size={32}/>
                                        : Number(item.monthSalesCY) > Number(item.monthSalesLY)
                                        ? <ArrowDropUp style={{ flex: 1, color: 'limegreen', fontSize: 32}} />
                                        : <ArrowDropDown style={{ flex: 1, color: 'red', fontSize: 32 }} /> 
                                    }
                                </div>
                                <div className='salesTabletOrange' style={{ flex: 1, marginBottom: 10, }}>
                                    <span className='tabletText'>{usdFormat.format(item.monthSalesCY)}</span>
                                </div>
                                <div className='salesTabletGrey' style={{ flex: 1, marginBottom: 10 }}>
                                    <span className='tabletText'>{usdFormat.format(item.monthSalesLY)}</span>
                                </div> 
                            </Row>
                        ))}
                    </Container>
                )
            case 'Tab2':
                return (
                    <Container className='bg-white'>
                        <Row 
                            style={{ display: 'flex', paddingInline: 20}}
                        >
                            <span 
                                className='headerText'
                                style={{ flex: 1 }}
                            >
                                Month
                            </span>
                            <div style={{ flex: 1 }}></div>
                            <span className='headerText' style={{ flex: 1 }}>Profit CY</span>
                            <span className='headerText' style={{ flex: 1 }}>Profit LY</span>
                        </Row>
                        <Divider style={{ marginBottom: 10, borderColor: 'gray' }} variant='middle'/>
                        {data.map((item, index) => (
                            <Row 
                                key={item.month} 
                                style={{ display: 'flex', paddingInline: 20 }}
                            >
                                <div style={{ flex: 1, marginBottom: 10 }}>
                                    <span className='headerText'>{item.month}</span>
                                </div>
                                <div style={{ flex: 1, marginBottom: 10 }}>
                                    {
                                        monthNames.indexOf(item.month) > monthIndex
                                        ? <DashIcon className='p-2' size={32}/>
                                        : Number(item.monthGrossProfitCY) > Number(item.monthGrossProfitLY)
                                        ? <ArrowDropUp style={{ flex: 1, color: 'limegreen', fontSize: 32}} />
                                        : <ArrowDropDown style={{ flex: 1, color: 'red', fontSize: 32 }} /> 
                                    }
                                </div>
                                <div className='salesTabletOrange' style={{ flex: 1, marginBottom: 10, }}>
                                    <span className='tabletText'>{usdFormat.format(Number(item.monthGrossProfitCY))}</span>
                                </div>
                                <div className='salesTabletGrey' style={{ flex: 1, marginBottom: 10 }}>
                                    <span className='tabletText'>{usdFormat.format(Number(item.monthGrossProfitLY))}</span>
                                </div> 
                            </Row>
                        ))}
                    </Container>
                )
        }
    }

    return (
        <>
            <Card 
                // style={styles.bigContainer}
            >
                <Row
                    style={{ 
                        display: 'flex', 
                        marginBlock: 10,
                    }}
                >
                    <div style={{ flex: 1 }}>
                        <Button
                            className={activeTab === 'Tab1' ? `tabButton bg-primary` : `tabButton bg-white`}
                            onClick={() => setActiveTab('Tab1')}
                        >
                            <span style={{ fontWeight: 'bold' }}>Sales</span>
                        </Button>
                    </div>
                    <div style={{ flex: 1 }}>
                        <Button
                            className={activeTab === 'Tab2' ? `tabButton bg-primary` : `tabButton bg-white`}
                            onClick={handleProfitTab}
                        >
                            <span style={{ fontWeight: 'bold' }}>Profit</span>
                        </Button>
                    </div>
                </Row>
                <Row>
                    {tabContent()}
                </Row>
            </Card>
        </>
    )
};

export default MonthlySalesReportCard;